import React, { Suspense, useState } from "react";
import { FaEnvelope, FaPhone } from "react-icons/fa";
import dynamic from "next/dynamic";
import Image from "next/image";
import Link from "next/link";
import useStore, { StoreState } from "../../../context/useStore";

const BookingForm = dynamic(() => import("./BookingForm"), {
  suspense: true,
});

const Panel = dynamic(() => import("./Panel"), {
  suspense: true,
});

interface ContactProps {
  mls: string;
  address: string;
}

const Contact: React.FC<ContactProps> = ({ mls, address }) => {
  const [show, setShow] = useState(false);
  const setDialog = useStore((state: StoreState) => state.setDialog);
  const auth = useStore((state: StoreState) => state.auth);

  return (
    <Suspense fallback={<></>}>
      <>
        <Panel
          Header={
            <div className="flex flex-col justify-center items-center">
              <Image
                src="/bungalow-color-logo.svg"
                alt="Bungalow Finder Logo"
                title="BungalowFinder Logo"
                width={270}
                height={27}
                priority
              />
            </div>
          }
        >
          <div className="flex flex-col gap-2 justify-center items-center">
            <span className="flex gap-2 justify-center items-center text-base">
              <FaPhone /> <a href="tel:+14183183766">(416) 828 7773</a>
            </span>
            <span className="flex gap-2 justify-center items-center text-base">
              <FaEnvelope />
              <a href="mailto:info@bungalowfinder.ca">info@bungalowfinder.ca</a>
            </span>
          </div>
        </Panel>
        <div className="mt-7 pt-3 pb-7 px-10 bg-white shadow-lg border border-gray-300 flex flex-col justify-center items-center gap-4">
          <h2 className="text-primary text-base font-normal">
            Ready to go See it?
          </h2>
          <div className="bg-primary w-full">
            <button
              onClick={() => {
                if (auth.login) {
                  setShow(true);
                } else {
                  setDialog({
                    closable: true,
                    open: true,
                  });
                }
              }}
              className="w-full bg-primary mix-blend-screen text-white py-2 font-normal text-sm"
            >
              Book A Showing
            </button>
          </div>
        </div>
        <div className="mt-7 pt-3 pb-7 px-10 bg-white shadow-lg border border-gray-300 flex flex-col justify-center items-center gap-4">
          <h2 className="text-primary text-base font-normal">
            Looking to Sell Your Bungalow?
          </h2>
          <Link href="/homeevaluation">
            <a className="bg-primary w-full text-white text-center">
              <div className="w-full bg-primary mix-blend-screen py-2">
                <span className="font-normal text-sm">Get Free Evaluation</span>
              </div>
            </a>
          </Link>
        </div>
        <BookingForm
          modalopen={show}
          address={address}
          handleModalClose={() => {
            setShow(false);
          }}
          mls={mls}
        />
      </>
    </Suspense>
  );
};

export default Contact;
